import { useState } from 'react';

import { get } from 'js/lib/user';

export const filterKeys = {
  LANGUAGE: 'language',
  LEVEL: 'level',
  SUBJECT: 'subject',
  PARTNER: 'partner',
  LEARNING_PRODUCT: 'learningProduct',
} as const;

export type FilterKeys = (typeof filterKeys)[keyof typeof filterKeys];
export type FilterState = { [key in FilterKeys]: string };
export const getDefaultFilterValues = (shouldDefaultToEnglish?: boolean) => ({
  [filterKeys.LANGUAGE]: shouldDefaultToEnglish ? 'en' : '',
  [filterKeys.LEVEL]: '',
  [filterKeys.SUBJECT]: '',
  [filterKeys.PARTNER]: '',
  [filterKeys.LEARNING_PRODUCT]: '',
});

const useProductFilterState = () => {
  const shouldUseEnglishAsDefaultLanguage = get()?.locale === 'en_US';
  const [filterValues, setFilterValues] = useState<FilterState>(
    getDefaultFilterValues(shouldUseEnglishAsDefaultLanguage)
  );

  const setFilterValue = (key: FilterKeys, value: string) => {
    setFilterValues((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const resetFilterValues = () => {
    // Reset truly resets to all default filters. English is only used as a default upon load.
    setFilterValues(getDefaultFilterValues());
  };

  return {
    filterValues,
    setFilterValue,
    resetFilterValues,
  };
};

export default useProductFilterState;
